import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Cms, TagColors } from '@impact/data';
import { TranslateModule } from '@ngx-translate/core';

import { LinkModule } from '../../link/link.module';
import { UtilsModule } from '../../utils/utils.module';

@Component({
    templateUrl: './workshop-service-spot.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

class WorkshopServiceSpotComponent {

    @HostBinding('class') class = 'workshop-service-spot';
    @Input() data: Cms.WorkshopServiceSpot;

    tagClasses: {};
    workshopService: Cms.WorkshopServiceSpot;

    ngOnInit() {
        this.workshopService = this.data;
        this.setTagClasses();
    }

    private setTagClasses() {
        this.tagClasses = {
            'workshop-service-spot__tag--blue': this.workshopService?.tagColor === TagColors.Blue,
            'workshop-service-spot__tag--green': this.workshopService?.tagColor === TagColors.Green
        };
    }
}

@NgModule({
    declarations: [WorkshopServiceSpotComponent],
    imports: [
        CommonModule,
        RouterModule,
        UtilsModule,
        LinkModule,
        TranslateModule.forChild()
    ]
})
class WorkshopServiceSpotModule {}

export const LazySpotComponent = WorkshopServiceSpotComponent;
